import { PKL_GRP } from '../shared/models/picklist.model';

export const PICKLIST_GROUPS = PKL_GRP;

// Helper to get all values as an array for the service
export const GLOBAL_PICKLIST_IDS = Object.values(PICKLIST_GROUPS);
